// extracted by mini-css-extract-plugin
export default {"video-wrapper":"_2y1nz","videoWrapper":"_2y1nz","preset-comment":"_3qSqO","presetComment":"_3qSqO","small-media":"FcM0q","smallMedia":"FcM0q","left":"_2JUN6","right":"_26eau"};